<div class="custom-tooltip">
  <ng-container *ngFor="let line of data">
    <p>{{ line }}</p>
  </ng-container>
</div>
